import axios from 'axios'
import { SALVAR_CONFIG_GRATUIDADE_TIPO_PRECO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function salvarConfigGratuidadeTipoPreco(empresaId, tipoEmissao, tiposPrecoPermitidos) {
  const url = `${URL}/empresas/${empresaId}/gratuidade-tipo-preco-config`;
  const body = { tipoEmissao, tiposPrecoPermitidos };
  return dispatch => axios.post(url, body, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: SALVAR_CONFIG_GRATUIDADE_TIPO_PRECO,
      payload: response
    })
  );
}
